/**
 * This is responsible for the button used to play/pause the read aloud feature at the bottom of
 * the reader page.
 */
import Backbone from "backbone";

interface Options {
  onPlay: () => void;
  onPause: () => void;
}

class ReadAloudButton extends Backbone.View {
  isPlaying = false;
  isBuffering = false;
  options: Options;

  constructor(options) {
    super(options);
    this.options = options;
    this.render();
  }

  events() {
    return {
      click: "toggle",
    };
  }

  toggle() {
    if (this.isPlaying) {
      this.isPlaying = false;
      this.options.onPause();
    } else {
      this.isPlaying = true;
      this.options.onPlay();
    }

    this.render();
  }

  setIsPlaying(isPlaying: boolean) {
    this.isPlaying = isPlaying;
    this.render();
  }

  setIsBuffering(isBuffering: boolean) {
    this.isBuffering = isBuffering;
    this.render();
  }

  render() {
    this.$el.html(
      this.isBuffering
        ? '<img class="throbber" src="/content/throbberBlack.gif" />'
        : `<svg class="icon" width="148" height="148" viewBox="0 0 148 148" fill="none" xmlns="http://www.w3.org/2000/svg">${
            this.isPlaying
              ? `<path fill-rule="evenodd" clip-rule="evenodd" d="M148 74C148 114.869 114.869 148 74 148C33.1309 148 0 114.869 0 74C0 33.1309 33.1309 0 74 0C114.869 0 148 33.1309 148 74ZM88 109C85.7909 109 84 107.209 84 105V42C84 39.7909 85.7909 38 88 38H101C103.209 38 105 39.7909 105 42V105C105 107.209 103.209 109 101 109H88ZM42 105C42 107.209 43.7909 109 46 109H59C61.2091 109 63 107.209 63 105V42C63 39.7909 61.2091 38 59 38H46C43.7909 38 42 39.7909 42 42V105Z" fill="currentColor"/>`
              : `<path fill-rule="evenodd" clip-rule="evenodd" d="M74 148C114.869 148 148 114.869 148 74C148 33.1309 114.869 0 74 0C33.1309 0 0 33.1309 0 74C0 114.869 33.1309 148 74 148ZM55 113.837L118 77.4641C120.667 75.9245 120.667 72.0755 118 70.5359L55 34.1628C52.3335 32.6232 49 34.5477 49 37.6269V110.373C49 113.452 52.3335 115.377 55 113.837Z" fill="currentColor"/>`
          }</svg>`
    );
    if (this.isBuffering) {
      this.$el.addClass("buffering");
    } else {
      this.$el.removeClass("buffering");
    }
    return this;
  }

  remove() {
    if (this.isPlaying) {
      this.isPlaying = false;
      this.options.onPause();
    }
    return this;
  }
}

export default ReadAloudButton;
